import {PersonalLabel} from "../domain/entities/personal-label.entity";
import {CommandName} from "./command-name.enum";
import {AbstractCommand} from "./abstract.command";

export class CreatePersonalLabelCommand extends AbstractCommand<PersonalLabel> {

    name = CommandName.CREATE_PERSONAL_LABEL;

    tags = ['entity', 'create', 'personal-label'];

}
